module.exports = __webpack_public_path__ + "static/fonts/Poppins-BoldItalic.19406f7.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Poppins-BoldItalic.ttf
// module id = 1020
// module chunks = 11